module.exports = __webpack_public_path__ + "media/images/landkit/icons/payment-methods/visa-19fa4b8aaac9cdca54c50f843ae877c2.svg";